export async function asyncPool<T>(
  concurrency: number,
  tasks: Array<() => Promise<T>>,
): Promise<Array<PromiseSettledResult<T>>> {
  const safeConcurrency = Math.max(1, Math.floor(concurrency));
  const results: Array<PromiseSettledResult<T>> = new Array(tasks.length);
  let nextTaskIndex = 0;

  const worker = async () => {
    while (true) {
      const currentIndex = nextTaskIndex;
      nextTaskIndex += 1;

      if (currentIndex >= tasks.length) {
        return;
      }

      try {
        const value = await tasks[currentIndex]();
        results[currentIndex] = { status: "fulfilled", value };
      } catch (reason) {
        results[currentIndex] = { status: "rejected", reason };
      }
    }
  };

  const workers = Array.from({ length: Math.min(safeConcurrency, tasks.length) }, () => {
    return worker();
  });

  await Promise.all(workers);
  return results;
}
